.container {
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;

    color: var(--mantine-color-black);

    h2 {
        font-weight: 400;
    }
    h3 {
        font-weight: 700;
        font-size: 17px;
    }

    div:has(p > thinking) {
        background-color: var(--mantine-color-red-2);
    }

    p {
        font-weight: 400;
        font-size: var(--mantine-font-size-md);
        line-height: 1.5;
        color: var(--mantine-color-dark-9);
    }

    hr {
        border: none;
        height: 1px;
        background-color: var(--mantine-color-gray-3);
        margin: var(--mantine-spacing-lg) 0;
    }

    ul, ol {
        font-size: var(--mantine-font-size-md);
        line-height: 1.5;
        color: var(--mantine-color-dark-9);
        padding-left: var(--mantine-spacing-xl);
        margin: var(--mantine-spacing-xs) 0;
    }

    li {
        margin: calc(var(--mantine-spacing-xs) / 2) 0;
    }

    li > ul, li > ol {
        margin: calc(var(--mantine-spacing-xs) / 2) 0;
    }
}

.tableWrapper {
    position: relative;
    margin: 1rem 0;
}

.table {
    font-size: 14px;

    & th {
        font-weight: 600;
        background-color: var(--mantine-color-gray-1);
    }

    & td,
    & th {
        padding: 0.625rem 0.75rem;
        vertical-align: top;
    }
}

.expandButton {
    position: absolute;
    bottom: 4px;
    right: 4px;
    opacity: 0.4;
    transition: opacity 150ms ease;
    background-color: var(--mantine-color-white);
    border: 1px solid var(--mantine-color-gray-3);
    border-radius: 4px;

    &:hover {
        opacity: 1;
        background-color: var(--mantine-color-gray-0);
    }
}

.modalBody {
    padding: 0;
    height: 100%;
}

.modalContent {
    background-color: rgba(0, 0, 0, 0.5);
}

.expandedTableContainer {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 2rem;
}

.closeButton {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background-color: var(--mantine-color-white);
    border: 1px solid var(--mantine-color-gray-3);
    border-radius: 4px;
    z-index: 10;

    &:hover {
        background-color: var(--mantine-color-gray-0);
    }
}

.expandedTableScroll {
    min-width: min(var(--app-thread-width), calc(100vw - 4rem));
    max-width: 100%;
    max-height: calc(100vh - 6rem);
    overflow: auto;
    background-color: var(--mantine-color-white);
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.hideCitations :global(.citation-badge) {
    display: none;
}

.expandedTable {
    font-size: 14px;

    & th {
        font-weight: 600;
        background-color: var(--mantine-color-gray-1);
    }

    & td,
    & th {
        padding: 0.75rem 1rem;
        vertical-align: top;
    }
}
